import React, {ReactNode} from 'react';

export enum ReviewLifecycleHelpArticle {
  CREATE_ENTRY_REVIEW_PROCESS = 'CREATE_ENTRY_REVIEW_PROCESS',
  ADD_AUDITORS_FOR_NOTEBOOK_REVIEWS = 'LEGACY_WITNESS_AND_REVIEW',
}

const ARTICLE_TO_URL = {
  [ReviewLifecycleHelpArticle.CREATE_ENTRY_REVIEW_PROCESS]:
    'https://help.benchling.com/hc/articles/10450761643917',
  [ReviewLifecycleHelpArticle.ADD_AUDITORS_FOR_NOTEBOOK_REVIEWS]:
    'https://help.benchling.com/hc/en-us/articles/9684260674189-Add-auditors-for-Notebook-reviews',
};

export default function WithReviewProcessHelpLink({
  helpArticle,
  children,
}: {
  helpArticle: ReviewLifecycleHelpArticle;
  children: ReactNode;
}): JSX.Element {
  return (
    <a href={ARTICLE_TO_URL[helpArticle]} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
